import React from "react";
import styles from "./WorkPatternImportErrors.module.css";

interface WorkPatternImportErrorsProps {
  errors: string[];
  title?: string;
}

/**
 * Renders a list of error strings from either CSV parse failures or API-level
 * errors (generic 422 / 409 / 5xx messages surfaced as strings).
 *
 * Per-row API validation errors from the `WorkPatternImportResult.errors[]`
 * envelope are displayed inline inside `WorkPatternImportTable`, not here.
 */
export function WorkPatternImportErrors({
  errors,
  title,
}: WorkPatternImportErrorsProps) {
  if (errors.length === 0) {
    return null;
  }

  return (
    <div className={styles.errorContainer} role="alert">
      <h4>{title ?? "Errors:"}</h4>
      <ul>
        {errors.map((error, index) => (
          <li key={index} className={styles.error}>
            {error}
          </li>
        ))}
      </ul>
    </div>
  );
}
